(function () {
  'use strict';

  const STORAGE_KEY = 'liveOrderToastDismissed';
  const FIRST_NAMES = [
    'Alex', 'Jordan', 'Taylor', 'Casey', 'Morgan', 'Riley', 'Avery', 'Quinn',
    'Noah', 'Liam', 'Emma', 'Mia', 'Olivia', 'Jack', 'Lucas', 'Ethan',
    'Sophia', 'James', 'Ben', 'Ryan', 'Kyle', 'Dylan', 'Chloe', 'Zoe',
    'Mason', 'Logan', 'Harper', 'Aiden', 'Isabella', 'Ella', 'Nathan', 'Grace',
    'Carter', 'Hannah', 'Leo', 'Ruby', 'Jayden', 'Lily', 'Owen', 'Nora',
  ];
  const TIME_LABELS_DESKTOP = [
    'just now',
    '1 minute ago',
    '2 minutes ago',
    '3 minutes ago',
    '5 minutes ago',
    '7 minutes ago',
    '9 minutes ago',
    '12 minutes ago',
  ];
  const TIME_LABELS_MOBILE = [
    'just now',
    '1m ago',
    '2m ago',
    '3m ago',
    '5m ago',
    '7m ago',
    '9m ago',
    '12m ago',
  ];

  function timeLabels() {
    return window.matchMedia('(max-width: 749px)').matches
      ? TIME_LABELS_MOBILE
      : TIME_LABELS_DESKTOP;
  }
  const IN_MS = 650;
  const OUT_MS = 400;

  function pickRandom(array) {
    return array[Math.floor(Math.random() * array.length)];
  }

  function maskName(name) {
    const clean = String(name || '').trim();
    if (clean.length <= 1) return clean + '****';
    if (clean.length === 2) return clean.charAt(0) + '*' + clean.charAt(1);
    const middleStars = '*'.repeat(Math.min(4, Math.max(3, clean.length - 2)));
    return clean.charAt(0) + middleStars + clean.charAt(clean.length - 1);
  }

  function generateMaskedName() {
    return maskName(pickRandom(FIRST_NAMES));
  }

  function pickProduct(products, lastIndex) {
    if (!products.length) return { product: null, index: -1 };
    if (products.length === 1) return { product: products[0], index: 0 };

    let index = Math.floor(Math.random() * products.length);
    let attempts = 0;
    while (index === lastIndex && attempts < 8) {
      index = Math.floor(Math.random() * products.length);
      attempts += 1;
    }
    return { product: products[index], index };
  }

  function runAnimation(el, className, fallbackMs) {
    return new Promise(function (resolve) {
      var finished = false;
      var timer = null;

      function finish() {
        if (finished) return;
        finished = true;
        el.removeEventListener('animationend', onEnd);
        if (timer) window.clearTimeout(timer);
        resolve();
      }

      function onEnd(event) {
        if (event.target !== el) return;
        finish();
      }

      el.addEventListener('animationend', onEnd);
      el.classList.remove(className);
      void el.offsetWidth;
      el.classList.add(className);
      timer = window.setTimeout(finish, fallbackMs + 100);
    });
  }

  function initToast(root) {
    if (!root || root.__liveOrderWired) return;
    root.__liveOrderWired = true;

    var configEl = root.querySelector('[data-live-order-config]');
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent || '{}');
    } catch (error) {
      return;
    }

    if (!config.enabled) return;
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return;

    var products = Array.isArray(config.products)
      ? config.products.filter(function (p) {
          return p && p.url && p.image;
        })
      : [];

    if (!products.length) return;

    var card = root.querySelector('[data-live-order-card]');
    var link = root.querySelector('[data-live-order-link]');
    var image = root.querySelector('[data-live-order-image]');
    var nameEl = root.querySelector('[data-live-order-name]');
    var timeEl = root.querySelector('[data-live-order-time]');
    var closeBtn = root.querySelector('[data-live-order-close]');

    if (!card || !link || !image || !nameEl || !timeEl || !closeBtn) return;

    var initialDelay = Math.max(0, Number(config.initialDelay) || 3) * 1000;
    var showDuration = Math.max(2, Number(config.showDuration) || 5) * 1000;
    var intervalGap = Math.max(3, Number(config.intervalGap) || 8) * 1000;

    var lastProductIndex = -1;
    var showTimer = null;
    var hideTimer = null;
    var cycleTimer = null;
    var isVisible = false;
    var isAnimating = false;
    var paused = document.hidden;

    function clearTimers() {
      if (showTimer) window.clearTimeout(showTimer);
      if (hideTimer) window.clearTimeout(hideTimer);
      if (cycleTimer) window.clearTimeout(cycleTimer);
      showTimer = hideTimer = cycleTimer = null;
    }

    function populate() {
      var picked = pickProduct(products, lastProductIndex);
      if (!picked.product) return;
      lastProductIndex = picked.index;

      image.src = picked.product.image;
      image.alt = picked.product.title || 'Recent order item';
      link.href = picked.product.url;
      nameEl.textContent = generateMaskedName();
      timeEl.textContent = pickRandom(timeLabels());
    }

    function resetCard() {
      card.classList.remove('is-mounted', 'is-entering', 'is-leaving');
    }

    function showCard() {
      if (paused || isAnimating || sessionStorage.getItem(STORAGE_KEY) === '1') return;

      populate();
      isAnimating = true;
      resetCard();
      root.setAttribute('aria-hidden', 'false');

      // 1) Mount first so display:flex is applied while still at the start pose.
      //    The reads in alignWithChat and the flush in runAnimation both settle
      //    that layout, so no extra forced read is needed here.
      card.classList.add('is-mounted');
      alignWithChat(root);

      // 2) Then run the enter keyframes.
      runAnimation(card, 'is-entering', IN_MS).then(function () {
        isAnimating = false;
        isVisible = true;
        hideTimer = window.setTimeout(function () {
          hideCard(true);
        }, showDuration);
      });
    }

    function hideCard(scheduleNext) {
      if (!card.classList.contains('is-mounted') || isAnimating) return;

      isAnimating = true;
      isVisible = false;
      root.setAttribute('aria-hidden', 'true');
      card.classList.remove('is-entering');

      runAnimation(card, 'is-leaving', OUT_MS).then(function () {
        resetCard();
        isAnimating = false;

        if (scheduleNext && !paused && sessionStorage.getItem(STORAGE_KEY) !== '1') {
          cycleTimer = window.setTimeout(showCard, intervalGap);
        }
      });
    }

    function dismiss(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      sessionStorage.setItem(STORAGE_KEY, '1');
      clearTimers();
      if (card.classList.contains('is-mounted')) {
        isAnimating = false;
        hideCard(false);
      } else {
        resetCard();
      }
    }

    closeBtn.addEventListener('click', dismiss);

    link.addEventListener('click', function (event) {
      if (event.target === closeBtn || closeBtn.contains(event.target)) {
        event.preventDefault();
      }
    });

    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
      if (paused) {
        clearTimers();
        isVisible = false;
        isAnimating = false;
        resetCard();
        return;
      }

      if (sessionStorage.getItem(STORAGE_KEY) !== '1') {
        cycleTimer = window.setTimeout(showCard, intervalGap);
      }
    });

    showTimer = window.setTimeout(showCard, initialDelay);
  }

  function findChatEl() {
    return (
      document.querySelector('#shopify-chat') ||
      document.querySelector('#ShopifyChat') ||
      document.querySelector('iframe#ShopifyChat') ||
      document.querySelector('[id*="shopify-chat"]') ||
      document.querySelector('[class*="shopify-chat"]') ||
      document.querySelector('button[aria-label*="Chat"]') ||
      document.querySelector('button[aria-label*="chat"]')
    );
  }

  function alignWithChat(root) {
    if (!root) return;

    var leftPad = 12;
    var gapToChat = 10;
    var chat = findChatEl();

    if (!chat) {
      root.style.setProperty('--live-order-z', '20');
      root.style.setProperty('--live-order-bottom', '16px');
      root.style.setProperty('--live-order-width', 'calc(100vw - 7rem)');
      return;
    }

    // Every geometric read happens up front. Interleaving them with the style
    // writes below made the browser flush layout once per property instead of
    // once per call.
    var chatZ = parseInt(window.getComputedStyle(chat).zIndex, 10);
    if (!Number.isFinite(chatZ)) {
      var node = chat.parentElement;
      while (node && node !== document.body) {
        chatZ = parseInt(window.getComputedStyle(node).zIndex, 10);
        if (Number.isFinite(chatZ)) break;
        node = node.parentElement;
      }
    }

    var rect = chat.getBoundingClientRect();
    var toastHeight = root.offsetHeight || 64;
    var viewportHeight = window.innerHeight;

    if (Number.isFinite(chatZ) && chatZ > 1) {
      root.style.setProperty('--live-order-z', String(Math.max(1, chatZ - 1)));
    } else {
      root.style.setProperty('--live-order-z', '20');
    }

    if (!rect || rect.height <= 0) return;

    // Stretch almost to the Chat pill (small gap between them).
    var width = Math.max(200, Math.round(rect.left - leftPad - gapToChat));
    root.style.setProperty('--live-order-width', width + 'px');
    root.style.maxWidth = width + 'px';

    // Vertically center with the Chat button on the same row.
    var chatCenterY = rect.top + rect.height / 2;
    var toastBottom = Math.round(viewportHeight - (chatCenterY + toastHeight / 2));
    root.style.setProperty('--live-order-bottom', Math.max(8, toastBottom) + 'px');
  }

  function boot() {
    document.querySelectorAll('[data-live-order-toast]').forEach(initToast);

    // Alignment only matters while a card is on screen, and showCard() realigns
    // immediately before each one enters — which also covers Inbox mounting late,
    // since the first card is delayed several seconds and every later card
    // realigns too. Polling for it from page load instead ran these layout reads
    // up to eleven times before anything was ever visible.
    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () {
        document.querySelectorAll('[data-live-order-toast]').forEach(function (root) {
          if (root.getAttribute('aria-hidden') === 'false') alignWithChat(root);
        });
      }, 150);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
